import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full max-w-md rounded-2xl border border-gray-200 bg-white p-8 text-left shadow-lg sm:text-center"
}
const _hoisted_2 = { class: "mt-3 whitespace-pre-line text-base leading-relaxed text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarLoader = _resolveComponent("BarLoader")!
  const _component_CognitoBrandedShell = _resolveComponent("CognitoBrandedShell")!

  return (_openBlock(), _createBlock(_component_CognitoBrandedShell, null, {
    default: _withCtx(() => [
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-lg font-semibold leading-snug text-red-600" }, " Could not continue ", -1)),
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1),
            _createElementVNode("button", {
              type: "button",
              class: "mt-8 w-full rounded-lg bg-[#9489F5] px-4 py-3 text-sm font-medium text-white shadow-sm hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#9489F5] focus:ring-offset-2 focus:ring-offset-white",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.returnToHome && _ctx.returnToHome(...args)))
            }, " Return to home ")
          ]))
        : (_openBlock(), _createBlock(_component_BarLoader, {
            key: 1,
            variant: "spinner",
            theme: "light",
            contained: "",
            message: "Getting things ready…"
          }))
    ]),
    _: 1
  }))
}